const GuardIndicatorsModule = () => import('@pages/vigilance/indicators/GuardIndicatorsModule.vue')
export default {
    path: 'guard-indicators',
    component: GuardIndicatorsModule,
    children: [
        {
            path: 'admin-guard-indicators',
            component: () => import('@pages/vigilance/indicators/GuardIndicators.vue'),
            name: 'adminGuardIndicators',
        },
    ],
}
